import roles from '@/store/modules/roles/roles'
import roleCreate from '@/store/modules/roles/role-create'
import roleEdit from '@/store/modules/roles/role-edit'

export default {
  roles,
  roleCreate,
  roleEdit
}
